import { AbstractModel, JsonObject, JsonProperty, DateConverter } from 'projects/core/src/public-api';
import { User } from 'projects/core/src/lib/login/data/user';
import { TicketStatus } from './ticket-status';

@JsonObject('model.project.Project')
export class TicketPriority extends AbstractModel {
	@JsonProperty(Number, 'id')
	id: number;

	@JsonProperty(String, 'name')
	name?: string;

	@JsonProperty(String, 'colour')
	colour?: string;
}
